module["exports"] = [
  "Österreich"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/default_country.js
// module id = 1114
// module chunks = 0